import { render, staticRenderFns } from "./SchoolDetailSetting.vue?vue&type=template&id=393a2a60&"
import script from "./SchoolDetailSetting.vue?vue&type=script&lang=ts&"
export * from "./SchoolDetailSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports